import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
// Icons
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import toast from "react-hot-toast";
import "./EliteLogin.css";

const FORGOT_PASSWORD_TOAST_DURATION = 4000;
const PASSWORD_RESET_SUCCESS_MESSAGE =
  "If an account exists for that email, a password reset link has been sent.";
const FORGOT_PASSWORD_IMAGE = "/register-login-pages/elite-core-forgot-password.png";

function ForgotPassword() {
  const history = useHistory();
  const [leavingForLogin, setLeavingForLogin] = useState(false);
  const returnTimer = useRef(null);
  useEffect(() => () => window.clearTimeout(returnTimer.current), []);
  const returnToLogin = (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (leavingForLogin) return;
    setLeavingForLogin(true);
    returnTimer.current = window.setTimeout(() => history.push("/login"), 420);
  };
  const initialValues = {
    email: "",
  };
  const validationSchema = Yup.object().shape({
    email: 
      Yup.string()
      .email("You must provide a valid email address.")
      .min(5, "Your email address must be a minimum of 5 characters.")
      .max(60, "Your email address must be a maximum of 60 characters.")
      .required("You must provide an email address that is between 4 to 60 characters."),
  });

  const forgotPassword = async (form, { resetForm, setSubmitting }) => {
    const data = { email: form.email };
    try {
      await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/forgot-password`,
        data
      );
      toast.success(PASSWORD_RESET_SUCCESS_MESSAGE, {
        duration: FORGOT_PASSWORD_TOAST_DURATION,
      });
      resetForm();
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Failed to send password reset link.",
        {
          duration: FORGOT_PASSWORD_TOAST_DURATION,
        }
      );
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <Formik
    initialValues={initialValues}
    onSubmit={forgotPassword}
    validationSchema={validationSchema}
  >
    {({ isSubmitting }) => (
    <Form className={`forgotPasswordContainer ec-reset-card ec-auth-page-enter${leavingForLogin ? " ec-auth-page-exit" : ""}`}>
      <div className="forgotPasswordForm forgotPassword-form-left-side  ec-reset-left">
      <div className="loginForm-inner ec-reset-inner">

      <div className="pagination">
          <div className="previousArrow">
            <Link to="/login" onClick={returnToLogin}><ArrowBackIcon/> Return to registration and login</Link>
          </div>
        </div>
        <h2 className="forgotPasswordForm-cta-heading"><span className="headline">Forgot Password</span></h2>
        <p className="forgotPassword-cta-paragraph">Forgot your password? Enter your email address and we&apos;ll send you a secure password reset link.</p>
        <label>Email address</label>
        <ErrorMessage name="email" component="span" />
        <Field
          type="text"
          name="email"
          placeholder="example@gmail.com"
        />
        <button disabled={isSubmitting}> {isSubmitting ? "Sending..." : "Send reset link"} </button>
        </div>
      </div>
      <div className="forgotPassword-form-right-side ec-reset-photo" style={{backgroundSize: "cover", backgroundPosition: "center center", backgroundImage: `url('${FORGOT_PASSWORD_IMAGE}')`}}>
      </div>
    </Form>
    )}
  </Formik>
  );
}

export default ForgotPassword;
